import { useSelector, TypedUseSelectorHook } from "react-redux";
import { PersistState } from "redux-persist";
import { AppStoreType } from "../../store";

export const useAppSelector: TypedUseSelectorHook<
  AppStoreType & { _persist: PersistState }
> = useSelector;
